module.exports = __webpack_public_path__ + "assets/img/switch-off.d823f865.svg";